import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import Home from './components/HomePage';
import HomeV2 from './components/HomePageV2';
import Swap from './components/Swap';
import Stake from './components/Stake';
import Stakebox from './components/Stakebox';
import Farm from './components/Farm';
import Vaults from './components/Vaults';
import Launchpad from './components/Launchpad';
import Pool from './components/Pool';
import Bridge from './components/Bridge';
import Faucet from './components/Faucet';
import Analytics from './components/Analytics';

function App() {
  return (
    <Router>
      <Switch>
        {/* <Route path="/analytics">
          <Analytics />
        </Route> */}
        {/* <Route path="/bridge">
          <Bridge />
        </Route> */}
        <Route path="/faucet">
          <Faucet />
        </Route>
        {/* <Route path="/pool">
          <Pool />
        </Route> */}
        <Route path="/launchpad">
          <Launchpad />
        </Route>
        {/* <Route path="/vaults">
          <Vaults />
        </Route> */}
        {/* <Route path="/farm">
          <Farm />
        </Route> */}
        <Route path="/stake">
          <Stake />
        </Route>
        <Route path="/stakebox">
          <Stakebox />
        </Route>
        {/* <Route path="/swap">
          <Swap />
        </Route> */}
        <Route path="/app">
          <HomeV2 />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
